export class Client {
    constructor(uri, token) {
        this.uri = uri;
        this.token = token;
    }
    async getMe() {
        return this.get('/v2/me');
    }
    async getCampaign(uid) {
        return this.get('/v2/campaigns/' + uid);
    }
    async getCampaigns() {
        return this.get('/v2/campaigns');
    }
    async getSectors() {
        return this.get('/v2/sectors');
    }
    async getProductsByCampaign(campaignUid) {
        return this.get('/v2/campaigns/' + campaignUid + '/products');
    }
    async getOrdersByCampaign(campaignUid) {
        return this.get('/v2/campaigns/' + campaignUid + '/orders');
    }
    async getDocument(uid) {
        return this.get('/v2/documents/' + uid);
    }
    async getProductsByDocument(uid) {
        return this.get('/v2/documents/' + uid + '/products');
    }
    async getOrdersByDocument(uid) {
        return this.get('/v2/documents/' + uid + '/orders');
    }
    async getDocuments() {
        return this.get('/v2/documents');
    }
    async getDocumentsByCampaign(campaignUid) {
        return this.get('/v2/campaigns/' + campaignUid + '/documents');
    }
    //TODO: get only webcatalogs
    async getOrders(shop_uid) {
        return this.get('/v2/shops/' + shop_uid + '/orders');
    }
    async getShops() {
        return this.get('/v2/shops');
    }
    async getShop(uid) {
        return this.get('/v2/shops/' + uid);
    }
    async getCategories() {
        return this.get('/v2/categories');
    }
    async getShopUid(shop_id) {
        let shops = await this.get('/v2/shops');
        for (let i = 0; i < shops.length; i++) {
            const shop = shops[i];
            if (shop.code === shop_id) {
                return Promise.resolve(shop.uid);
            }
        }
        return Promise.reject();
    }
    async getGeoAreas() {
        return this.get('/v2/geoareas');
    }
    async getLogs(entity, uid) {
        return this.get('/v2/logs?name=' + entity + '&uid=' + uid + '&age=36000h');
    }
    async getLogsEntityNames() {
        return this.get('/v2/logs/entities/names');
    }
    async getUser(uid) {
        return this.get('/v2/users/' + uid);
    }
    async postDatafile(body, contentType) {
        let header = new Headers();
        header.append('Content-Type', contentType);
        return this.post('/v2/datafiles', body, header);
    }
    async createCampaign(newCampaign) {
        return this.post('/v2/campaigns/globals', newCampaign, null);
    }
    async createMilestonesByCampaign(campaignUid, newMilestone) {
        return this.post('/v2/campaigns/' + campaignUid + '/milestones', newMilestone, null);
    }
    async createPage(campaignUid, createPageIn = { width: 599, height: 749 }) {
        return this.post('/v2/campaigns/' + campaignUid + '/pages', createPageIn, null);
    }
    async createDocument(campaignUid, newdocument) {
        return this.post('/v2/campaigns/' + campaignUid + '/documents', newdocument, null);
    }
    async createPageVersion(pageUid, datafileUid = "f0c40fdfdf564559b7062472c3551d8c") {
        await this.post('/v2/document-pages/' + pageUid + '/versions', { wiprender_uid: datafileUid, wip_uid: datafileUid }, null);
        await this.put('/v2/document-pages/' + pageUid + '/versions/last/annotations', { annotations_uid: datafileUid }, null);
        return await this.put('/v2/document-pages/' + pageUid + '/versions/last/candidate', { candidate_uid: datafileUid }, null);
    }
    async updateDocumentGroup(documentUid, group) {
        let body = { group };
        return this.put('/v2/documents/' + documentUid + '/group', body, null);
    }
    async updateDocumentOrderOption(documentUid, order_option) {
        let body = { order_option };
        return this.put('/v2/documents/' + documentUid + '/order-option', body, null);
    }
    async updateMilestoneCampaign(campaignUid, milestoneUid, newMilestone) {
        return this.put('/v2/campaigns/' + campaignUid + '/milestones/' + milestoneUid, newMilestone, null);
    }
    async updateDocument(documentUid, updateDocumentIn) {
        return this.patch('/v2/documents/' + documentUid, updateDocumentIn, null);
    }
    async putCampaign(uid, body) {
        return this.put('/v2/campaigns/' + uid, body, null);
    }
    async putCampaignMilestone(uidCampaign, uidMilstone, body) {
        return this.put('/v2/campaigns/' + uidCampaign + '/milestones/' + uidMilstone, body, null);
    }
    async putWebCatalog(uidOrder, body) {
        return this.put('/v2/orders/' + uidOrder + "/webcatalog", body, null);
    }
    async putProductToPage(uidProduct, uidPage, body = { Hmm: 1, Wmm: 1, Xmm: 0, Ymm: 0 }) {
        return this.put('/v2/document-pages/' + uidPage + '/versions/last/products/' + uidProduct, body, null);
    }
    async addPageToDocument(documentUid, pageUid, body = { Anchor: "", Dryrun: false, Op: "back" }) {
        return this.put('/v2/documents/' + documentUid + '/pages/' + pageUid, body, null);
    }
    async addSectorToPage(pageUid, sectorUid) {
        return this.put('/v2/document-pages/' + pageUid + '/sectors/' + sectorUid, {}, null);
    }
    async get(path) {
        return this.request('GET', path, null, null);
    }
    async post(path, body, headers) {
        return this.request('POST', path, body, headers);
    }
    async put(path, body, headers) {
        return this.request('PUT', path, body, headers);
    }
    async delete(path, body, headers) {
        return this.request('DELETE', path, body, headers);
    }
    async patch(path, body, headers) {
        return this.request('PATCH', path, body, headers);
    }
    async request(method, path, body, headers) {
        const response = await fetch(this.uri + path, this.params(method, body, headers));
        if (response.status >= 400) {
            return Promise.reject(response);
        }
        if (response.headers.get('Content-Type').includes('application/json') && response.status != 204) {
            return response.json();
        }
        else {
            return response;
        }
    }
    params(method, body, headers) {
        if (!headers) {
            headers = new Headers();
        }
        headers.append('Authorization', 'Bearer ' + this.token);
        if (body) {
            if (headers.get("Content-Type") === null) {
                headers.append('Content-Type', 'application/json');
            }
        }
        let params = {
            method: method,
            mode: 'cors',
            headers: headers,
            body: null,
        };
        if (body) {
            if (headers.get("Content-Type") === "application/json") {
                params.body = JSON.stringify(body);
            }
            else {
                params.body = body;
            }
        }
        return params;
    }
    async UpdateMilestoneByName(campaign, milestoneName, dateValue) {
        return new Promise((res, rej) => {
            const ml = campaign.milestones.find(e => e.name === milestoneName);
            const newDate = {
                name: ml.name,
                date: dateValue,
                kind: ml.kind,
                brand_uids: ml.brand_uids
            };
            return this.updateMilestoneCampaign(campaign.uid, ml.uid, newDate)
                .then(mlst => {
                res(mlst);
            })
                .catch(err => {
                rej(err);
            });
        });
    }
}
var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["Generic"] = 0] = "Generic";
    ErrorCode[ErrorCode["Missing"] = 1] = "Missing";
    ErrorCode[ErrorCode["MissingField"] = 2] = "MissingField";
    ErrorCode[ErrorCode["Invalid"] = 3] = "Invalid";
    ErrorCode[ErrorCode["AlreadyExists"] = 4] = "AlreadyExists";
    ErrorCode[ErrorCode["Undeletable"] = 5] = "Undeletable";
    ErrorCode[ErrorCode["Unauthorized"] = 6] = "Unauthorized";
    ErrorCode[ErrorCode["Immutable"] = 7] = "Immutable";
    ErrorCode[ErrorCode["Forbidden"] = 8] = "Forbidden";
    ErrorCode[ErrorCode["Consistency"] = 9] = "Consistency";
})(ErrorCode || (ErrorCode = {}));
